import React from 'react';
import { Button, Color, Variant } from '@signaturit/react-components-library';
import { useTranslation } from 'react-i18next';
import { ASSETS_PATH } from '../../../constants/endpoints';
import { useSideBarButtonStyles } from './SideNavigationMenu.styles';

export type SideBarButtonProps = {
    showCertificateButton: string | boolean;
    handleOpenNewCertifiedFileModal: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    handleOpenNewRequestModal: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

export const SideBarButton = ({
    showCertificateButton,
    handleOpenNewCertifiedFileModal,
    handleOpenNewRequestModal,
}: SideBarButtonProps) => {
    const iconBasePath = `${ASSETS_PATH}/img/menu/`;
    const classes = useSideBarButtonStyles();
    const { t } = useTranslation();

    return (
        <>
            <Button
                name="sidebar-button"
                variant={Variant.contained}
                fullWidth={true}
                color={Color.primary}
                onClick={showCertificateButton ? handleOpenNewCertifiedFileModal : handleOpenNewRequestModal}
            >
                <span className={classes.containerButton}>
                    <img className={classes.iconButton} src={`${iconBasePath}icon-button-send.svg`} />
                    <span>
                        {showCertificateButton
                            ? t('default.menus._left.certify_file')
                            : t('default.menus._left.new_request')}
                    </span>
                </span>
            </Button>
        </>
    );
};
